import { FC } from 'react'

import { FF, FormType, RadioGroup, Select, TextareaInput } from 'ui/components'
import { Col, Col2x, FormRow } from 'ui/themes/globalStyles'

import { QuestionnaireDemo } from '../../../../../../types'
import * as SC from '../../../../style'

export const CashActivity: FC<{ formApi: FormType<QuestionnaireDemo> }> = ({ formApi }) => {
  return (
    <>
      <FormRow>
        <Col2x>
          <SC.MainText>
            The business receives substantially more revenue than may reasonably be expected given the relevant
            limitations imposed by the state in which it operates. The business makes cash deposits or withdrawals over
            a short period of time that are excessive related to local competitors or the expected activity of the
            business.
          </SC.MainText>
        </Col2x>
      </FormRow>
      <FormRow>
        <Col>
          <SC.SecondText>
            Cash activity is analyzed to determine whether suspicious patterns have been identified and such activity is
            compared to customer's historical activity. This activity can also be compared to the customer's Commercial
            Risk Rating Worksheet for a new customer or if further EDD is necessary.
          </SC.SecondText>
        </Col>
        <Col>
          <formApi.Field
            name="cashActivityAnalyzed"
            children={(field) => <FF field={field} input={(p) => <RadioGroup yesNo {...p} valueType="boolean" />} />}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col>
          <formApi.Field
            name="cashActivityVariance"
            children={(field) => (
              <FF
                field={field}
                label="Is activity within variance?"
                input={(p) => (
                  <Select
                    data={[
                      {
                        label: 'All activity in Variance',
                        value: 'All activity in Variance'
                      },
                      {
                        label: 'See validated Variance and/or Annual Questions',
                        value: 'See validated Variance and/or Annual Questions'
                      },
                      {
                        label: 'New Account - No historical data',
                        value: 'New Account'
                      },
                      {
                        label: 'Other - See Comments',
                        value: 'other'
                      }
                    ]}
                    {...p}
                  />
                )}
              />
            )}
          />
        </Col>
      </FormRow>
      <FormRow>
        <Col2x>
          <formApi.Field
            name="cashActivityComments"
            children={(field) => (
              <FF field={field} label="Comments" input={(p) => <TextareaInput maxLength={5000} {...p} />} />
            )}
          />
        </Col2x>
      </FormRow>
    </>
  )
}
